import { graphql } from "react-relay";

export const enrol_pupil = graphql`
  mutation EnrolPupilMutation($input: EnrolPupilInput!) {
    enrolPupil(input: $input) {
      success
      errors
      enrolment {
        id
        status
        enroledTimestamp
        positionInWaitingList
        enroledParent {
          id
          user {
            id
            firstName
            lastName
          }
        }
        enroledPupil {
          id
          user {
            id
            firstName
            lastName
          }
        }
      }
      lessonBlock {
        id
        pupil {
          id
          user {
            id
            firstName
            lastName
          }
        }
      }
      updatedEnrolmentOffers {
        id
        archived
        offerAccepted
      }
      updatedEnrolmentsInWaitingList {
        id
        positionInWaitingList
      }
    }
  }
`;
